<template>
  <v-container id="dashboard" fluid point="section">
    <!-- OPTIONS & MANAGEMENT WIDGETS -->
    <v-row v-if="userLevelAboveAdmin">
      <!-- SEARCH FORM -->
      <v-col cols="12" md="6">
        <v-card class="my-0">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-radio-group row v-model="form.search.searchBy">
                    <template v-slot:label>
                      <div>{{ $t("points.searchBy") }}<br /></div>
                    </template>
                    <v-radio
                      :label="$t('points.name')"
                      value="name"
                    ></v-radio>
                    <!-- <v-radio :label="$t('views.commissionFee.rate')" value="rate"></v-radio> -->
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex justify-space-between">
                  <v-form @submit.native.prevent @submit="search">
                    <v-text-field
                      dense
                      outlined
                      v-model="form.search.keyword"
                      placeholder="(keyword)"
                      clearable
                    >
                    </v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- BUTTONS FOR CREATION -->
      <!-- <v-col cols="12" md="6" class="d-flex justify-end">
        <div>
          <v-btn x-large block rounded @click="addPoint" color="primary">
            <v-icon left>mdi-plus-box-outline</v-icon>
            {{ $t("points.add") }}
          </v-btn>
        </div>
      </v-col> -->
    </v-row>

    <!-- LIST OF points -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <SSRTable ref="point-list" :data-url="loadUrl" :data-key="'data'" :schema="schema">

            <!-- <SSRTable
              ref="point-list"
              :data="points"
              :schema="schema"
            > -->
              

              <!-- 狀態（啟用/停用） -->
              <div slot="isEnabled" slot-scope="{ item }">
                <v-switch
                  v-model="item.isEnabled"
                  color="success"
                  inset
                  :disabled="true"
                  @change="onToggleActive(item)"
                />
              </div>

              <!-- 時間 -->
              <div slot="createdAt" slot-scope="{ item }">
                {{ formatDate(item.createdAt) }}
              </div>
              <div slot="actions" slot-scope="{ item }">
               
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  color="info"
                  @click="showApplyDialog(item)"
                >
                  <v-icon>mdi-store-cog</v-icon>
                </v-btn>
              </div>
            </SSRTable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog - apply  point -->
    <v-dialog v-model="dialog.apply.show" @input="onApplyDialogChange">
      <v-card>
        <v-card-title>
          <strong> {{ $t("points.apply") }} | {{ selectedPoint.pointName }}</strong>
          <v-card-subtitle>設定店家於店家後台可以開通使用哪些點數</v-card-subtitle>
        </v-card-title>
        
        <v-card-text v-if="dialog.apply.show">
          <Settings ref="mySettings" :point="selectedPoint"/>
        </v-card-text>
      </v-card>
    </v-dialog>
   
  </v-container>
</template>

<script>
import SSRTable from "@/components/SSRTable";

import SimpleVueValidation from "simple-vue-validator";
import axios from "axios";
import Settings from "./Settings.vue";

const Validator = SimpleVueValidation.Validator;

export default {
  components: {
    SSRTable,
    Settings
  },

  mounted() {
    this.fetchAds();
  },

  methods: {
    async fetchAds() {
      this.loading = true;
      // 模擬從 API 獲取資料
      setTimeout(() => {
        const mock = {
          points: [
            {
              "pointId": 1,
              "pointName": "小樹點",
              "isEnabled": true,
              "createdAt": 1671638399
            }
          ]
        };
        this.points = mock.points;
        this.loading = false;
      }, 500);
    },
    formatDate(ts) {
      return new Date(ts * 1000).toLocaleString();
    },
    
    search() {
      console.log("[DEBUG] search", this.form.search);
      if (this.form.search.keyword)
        this.form.search.searchQueryString = `search=${
          this.form.search.searchBy
        }:${encodeURIComponent(this.form.search.keyword)}`;
      else this.form.search.searchQueryString = "";
    },
    
    showApplyDialog(item) {
      this.dialog.apply.show = true;
      this.selectedPoint = item;
    },

    onApplyDialogChange(val) {
      if (!val) {
        //console.log('Dialog was closed');
        // 呼叫子組件的 resetSearchFields 方法
        if (this.$refs.mySettings) {
          this.$refs.mySettings.reset();
        }
      }
    },
  },

  data() {
    return {
      scope: {},
      points: [],
      selectedPoint: {
        pointName:'',
        pointId: '',
      },
      loading: false,
      form: {
        search: {
          searchBy: "name",
          keyword: "",
          searchQueryString: ""
        }
      },
      dialog: {
        apply: {
          show: false, 
          isLoading: false,
          
        }
      },
      };
  },
  watch: {},

  computed: {
    loadUrl() {
      return (
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/core/points-usages` +
        (this.form.search.searchQueryString
          ? `?${this.form.search.searchQueryString}`
          : "")
      );
    },

    schema() {
      let ret = [
        { text: this.$t('points.id'), value: "pointId", sortable: false },
        { text: this.$t('points.name'), value: "pointName", sortable: false },
        // { text: this.$t('points.activeStatus'), value: "isEnabled", sortable: false },
        // { text: this.$t('points.createdAt'), value: "createdAt" },
        { text: this.$t('points.action'), value: "actions", sortable: false }
      ];
      return ret;
    },

    user() {
      return this.$store.getters.user;
    },
    userLevelAboveAdmin() {
      return ["superadmin"].indexOf(this.$store.getters.user["level"]) >= 0;
    }
  },
};
</script>
